import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { TextareaAutosize } from "@mui/base";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import { AllPriorityList } from "../../api/casp/priority";
import * as Yup from "yup";
import { useFormik } from "formik";
import { withTranslation } from "react-i18next";

const ChangeRequestMeta = (props) => {
  // const loggedInUser = useSelector((state) => state.Profile.user);
  const [newChangeRequestObject, setNewChangeRequestObject] = useState({
    description: "",
    reason: "",
    impact: "",
    comments: "",
    negativeImpact: "",
    priority: {},
  });

  const changeRequestValidation = Yup.object().shape({
    description: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .required(props.t("Please enter description")),
    reason: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .required(props.t("Please enter reason")),
    impact: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .required(props.t("Please enter impact")),
    negativeImpact: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .required(props.t("Please enter negative impact")),
    comments: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .optional(),
    priority: Yup.object().shape({
      id: Yup.number().required(props.t("Please select priority")),
    }),
  });

  const formik = useFormik({
    initialValues: {
      ...newChangeRequestObject,
    },
    validationSchema: changeRequestValidation,
    validateOnMount: true,
    onSubmit: () => {
    },
  });

  useEffect(() => {
    if (formik.isValid) {
      props?.setChangeRequestMetaInfo({
        ...formik.values
      })
    }
    props?.setChangeRequestIsValid(formik.isValid)
  }, [formik.isValid])


  return (
    <div>
      {/* <Card className="customCard changeReqCard"> */}
        <div className="impact d-flex flex-column position-relative" style={{ marginBottom: '12px'}}>
          {/* <label className="position-absolute abs-label">
            {props.t('Describe the change')} *
            </label> */}
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="description"
            disabled={props?.isLoading || props?.isLoadingForButtons}
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder={`${props.t('Describe the change')} *`}
            required
          />
          {formik.touched.description && formik.errors.description && (
            <span className="text-danger">{formik.errors.description}</span>
          )}
        </div>
      {/* </Card> */}

      {/* <Card className="customCard changeReqCard"> */}
        <div className="impact d-flex flex-column position-relative" style={{ marginBottom: '12px'}}>
          {/* <label className="position-absolute abs-label">
            {props.t('Reason for the change')} *
            </label> */}
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="reason"
            disabled={props?.isLoading || props?.isLoadingForButtons}
            value={formik.values.reason}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder={`${props.t('Reason for the change')} *` }
            required
          />
          {formik.touched.reason && formik.errors.reason && (
            <span className="text-danger">{formik.errors.reason}</span>
          )}
        </div>
      {/* </Card> */}

      {/* <Card className="customCard changeReqCard"> */}
      <div className="impact d-flex flex-column position-relative" style={{ marginBottom: '12px'}}>
        {/* <label className="position-absolute abs-label">
            {props.t('Impact for the change')} *
            </label> */}
        <TextareaAutosize
          className="position-relative"
          minRows="2"
          name="impact"
          disabled={props?.isLoading || props?.isLoadingForButtons}
          value={formik.values.impact}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder={`${props.t('Impact for the change')} *`}
          required
        />
        {formik.touched.impact && formik.errors.impact && (
          <span className="text-danger">{formik.errors.impact}</span>
        )}
      </div>
      {/* </Card> */}

      <div style={{ marginBottom: '12px'}}>
        <SearchDropDownListPaginationComponent
          label={`${props.t("Select Priority Level")} *`}
          required
          disabled={props?.isLoadingForButtons || props?.isLoading}
          searchEnabled={false}
          listCall={AllPriorityList}
          emitItem={(newValue) => {
            setNewChangeRequestObject({
              ...newChangeRequestObject,
              priority: newValue,
            });
            formik.setFieldValue("priority", newValue ? newValue : "");
          }}
          onBlur={() => {
            if (!formik.touched?.priority) {
              formik.setFieldTouched("priority.id", true, true);
            }
          }}

        />
        {formik.touched.priority?.id && formik.errors.priority?.id && (
          <span className="text-danger">{formik.errors.priority.id}</span>
        )}
      </div>

      {/* <Card className="customCard changeReqCard"> */}
      <div className="impact d-flex flex-column position-relative" style={{ marginBottom: '12px'}}>
        {/* <label className="position-absolute abs-label">
            {props.t('Specify the impact if the change request is not approved')} *
            </label> */}
        <TextareaAutosize
          className="position-relative"
          minRows="2"
          name="negativeImpact"
          disabled={props?.isLoading || props?.isLoadingForButtons}
          value={formik.values.negativeImpact}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder={`${props.t('Specify the impact if the change request is not approved')} *`}
          required
        />
        {formik.touched.negativeImpact &&
          formik.errors.negativeImpact && (
            <span className="text-danger">
              {formik.errors.negativeImpact}
            </span>
          )}
      </div>
      {/* </Card> */}
    </div>
  );
}

export default withTranslation()(ChangeRequestMeta);

